import Select from './component.vue';


export default Select;
